/* DSL Checkout-bot — minimal scripted Q&A on cart page */
(function(){
  if (location.pathname !== "/cart") return;
  var bot = document.createElement("aside");
  bot.className = "dsl-checkout-bot";
  bot.innerHTML = "<button class=\"dsl-checkout-bot__toggle\" aria-label=\"Open checkout-bot\">💬</button>" +
    "<div class=\"dsl-checkout-bot__panel\" hidden><h4>Hulp bij checkout?</h4>" +
    "<button data-q=\"shipping\">Hoe lang duurt verzending?</button>" +
    "<button data-q=\"return\">Wat is jullie retourbeleid?</button>" +
    "<button data-q=\"size\">Welk product past bij mij?</button>" +
    "<div data-bot-answer></div></div>";
  document.body.appendChild(bot);
  var ANSWERS = {
    shipping: "📦 Bezorging: 1-2 werkdagen NL, 3-5 werkdagen BE/DE. Gratis vanaf €99.",
    return: "🔄 30 dagen retour, gratis. Stuur retour aan via /pages/returns.",
    size: "💡 Niet zeker? Doe onze skin-quiz: /pages/skin-quiz."
  };
  bot.querySelector(".dsl-checkout-bot__toggle").addEventListener("click", function(){
    bot.querySelector(".dsl-checkout-bot__panel").hidden = !bot.querySelector(".dsl-checkout-bot__panel").hidden;
  });
  bot.querySelectorAll("[data-q]").forEach(function(b){
    b.addEventListener("click", function(){
      bot.querySelector("[data-bot-answer]").textContent = ANSWERS[b.dataset.q];
      if (window.DSL_AB) window.DSL_AB.track("bot_answer", {q: b.dataset.q});
    });
  });
})();